import React, { useEffect, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { Button, Checkbox, Form, Input, Select, Tag, Row, Col } from "antd";
import commonConfig from "../../../commonConfig.json";
import TagInput from "./TagInput";

const { TextArea } = Input;
const exportTypes = commonConfig.exportTypes;
const emailBodyLimit = 500;

const ExcelShareForm = (props) => {
  const [disableSend, setDisableSend] = useState({
    reports: false,
    recipients: false,
    ccUser: false,
  });
  const [emailBody, setEmailBody] = useState("");
  const [emailBodyMaxLength, setEmailBodyMaxLength] = useState(emailBodyLimit);
  const [recipientErrors, setRecipientErrors] = useState([]);
  const [tagList, setTagList] = useState([]);
  const {
    handleExcelExport,
    exportDefaultSubject,
    validComplianceShareDomains,
    handleClose,
  } = props;

  const preventAutoSubmission = (event) => {
    if (event.code === "Enter" && event.target.id !== "excelShare_emailBody") {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  window.addEventListener("keydown", preventAutoSubmission);

  const [form] = Form.useForm();
  const loggedUserData = useSelector(
    (state) => state.userDetailReducer,
    shallowEqual
  );

  const updateDisabled = (newValue, field, origin) => {
    let newDisableSend = { ...disableSend };
    newDisableSend[field] = newValue;
    setDisableSend(newDisableSend);
  };

  const reportSelected = (selectedReports) => {
    if (selectedReports.length > 0) {
      updateDisabled(true, "reports");
    } else {
      updateDisabled(false, "reports");
    }
  };

  const mailToUserSelected = (e) => {
    console.log("Checked", e);
    if (e.target.checked) {
      updateDisabled(true, "ccUser");
    } else {
      updateDisabled(false, "ccUser");
    }
  };

  const validations = (currentTag, allTags, index, errors) => {
    let errorList = errors || [...recipientErrors];
    let tagStatus = true;
    let error = null;
    let validEmailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    let emailSuffix = currentTag.split("@")[1] || false;
    if (!currentTag.match(validEmailRegex)) {
      tagStatus = false;
      error = "One or more Email Address are invalid";
    } else if (
      !emailSuffix ||
      (validComplianceShareDomains.length > 0 &&
        !validComplianceShareDomains.includes(emailSuffix))
    ) {
      tagStatus = false;
      error = error || "One or more Email Address are unapproved";
    }

    console.log(currentTag, index, allTags);

    if (!error) {
      for (let x = 0; x < allTags.length; x++) {
        let tag = allTags[x];
        if (currentTag === tag.value && (index == undefined || index != x)) {
          tag.status = false;
          tagStatus = false;
          error = error || "One or more Email Address are duplicated";
          break;
        }
      }
    }

    if (error && !errorList.includes(error)) {
      errorList.push(error);
      setRecipientErrors(errorList);
      form.setFields([
        {
          name: "recipients",
          errors: errorList,
        },
      ]);
    }

    if (errorList.length > 0 || !tagStatus || error !== null) {
      updateDisabled(false, "recipients", "validations");
    } else {
      updateDisabled(true, "recipients", "validations");
    }
    return tagStatus;
  };

  const formValidator = (rule, recipients) => {
    // let recipients = form.getFieldValue("recipients");
    if (!disableSend.ccUser && (!recipients || recipients.length === 0)) {
      updateDisabled(false, "recipients");
      return Promise.reject("Please enter an email");
    }

    if (recipientErrors.length > 0) {
      updateDisabled(false, "recipients");
      return Promise.reject(recipientErrors);
    }

    updateDisabled(true, "recipients", "frmValidations");
    return Promise.resolve(true);
  };

  const clearTagErrors = () => {
    setRecipientErrors([]);
    form.setFields([
      {
        name: "recipients",
        errors: [],
      },
    ]);
    // forceUpdate();
  };

  useEffect(() => {
    if (tagList.length === 0) {
      updateDisabled(false, "recipients");
    }
  }, [tagList]);

  const updateTags = (newList) => {
    setTagList(newList);
    form.setFields([
      {
        name: "recipients",
        value: newList,
      },
    ]);
  };

  const onFinish = (values) => {
    console.log("Success:", values);
    if (values.mailToUser) {
      const currentUser = {
        value: loggedUserData.userEmail,
        status: true,
      };

      if (!values.recipients) {
        values.recipients = [currentUser];
      } else {
        let contains = false;
        for (let x = 0; x < values.recipients.length; x++) {
          if (values.recipients[x].value === loggedUserData.userEmail) {
            contains = true;
            break;
          }
        }
        if (!contains) {
          values.recipients.push(currentUser);
        }
      }
    }
    if (values.emailSubject && values.emailSubject.trim() !== "") {
      values.emailSubject = "- " + values.emailSubject;
    }
    handleExcelExport(values, true);
    handleClose();
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const emailBodyChanged = (e) => {
    const lineBreakRegex = /\n/g;
    const newValue = e.target.value;
    const newChar =
      newValue.length > emailBody.length
        ? findTheDifference(newValue, emailBody)
        : null;
    const contentLength = newValue.replaceAll(lineBreakRegex, "").length;
    const lineBreaks = (newValue.match(lineBreakRegex) || []).length;
    if (contentLength <= emailBodyLimit || (newChar && newChar == "\n")) {
      setEmailBody(newValue);
      setEmailBodyMaxLength(emailBodyLimit + lineBreaks);
    } else {
      setEmailBody(emailBody + "");
    }
  };

  const findTheDifference = (s, t) => {
    let i = 0;
    while (s[i] || t[i]) {
      if (s.charAt(i) !== t.charAt(i)) {
        break;
      }
      i++;
    }

    return { diff: s.substr(i, 1), index: i };
  };

  const emailSubjectChanged = (e) => {
    if (e.target.value.length >= 50) {
      form.setFields([
        {
          name: "emailSubject",
          errors: ["Email Subject should not be more than 50 characters"],
        },
      ]);
    } else {
      form.setFields([
        {
          name: "emailSubject",
          errors: [],
        },
      ]);
    }
  };

  const reports = [
    { label: "Compliance Status", value: exportTypes.PERCENTAGE },
    { label: "Missing Reports", value: exportTypes.MISSING_REPORTS },
  ];

  if (props.status === "Signature Status" || props.status === "All") {
    reports.push({
      label: "Signer Details",
      value: exportTypes.SIGNER_DETAILS,
    });
  }

  if (props.status === "Report Status" || props.status === "All") {
    reports.push({
      label: "Missing Reports - Timestamp",
      value: exportTypes.REPORT_STATUS_TIMESTAMP,
    });
  }

  let col1 = [],
    col2 = [];
  let flag = true;
  for (const report of reports) {
    if (flag) {
      col1.push(
        <Row>
          <Checkbox value={report.value}>{report.label}</Checkbox>
        </Row>
      );
    } else {
      col2.push(
        <Row>
          <Checkbox value={report.value}>{report.label}</Checkbox>
        </Row>
      );
    }
    flag = !flag;
  }

  return (
    <>
      <Form
        layout="vertical"
        name="excelShare"
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 24,
        }}
        autoComplete="off"
        form={form}
        // onValuesChange={onValuesChange}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        style={{ width: "100%" }}
        requiredMark={false}
      >
        <Form.Item
          label={
            <span className="excel-share-modal-grey excel-share-modal-form-label">
              Select the report to email
            </span>
          }
          name="reportList"
          rules={[
            {
              required: true,
              message: "Please select a report",
            },
          ]}
          className="shareModalReportRow"
        >
          <Checkbox.Group onChange={reportSelected}>
            <Row>
              <Col className="shareFormReoprtsCol">{col1}</Col>
              <Col className="shareFormReoprtsCol">{col2}</Col>
            </Row>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item
          label={
            <span className="excel-share-modal-grey excel-share-modal-form-label">
              To
            </span>
          }
          name="recipients"
          rules={[
            {
              validator: formValidator,
            },
          ]}
        >
          <TagInput
            closable
            log
            validations={validations}
            updateTags={updateTags}
            tagList={tagList}
            clearTagErrors={clearTagErrors}
          />
        </Form.Item>

        <Form.Item
          label={
            <div>
              <span className="excel-share-modal-grey ">
                <span className="excel-share-modal-form-label">
                  Email Subject
                </span>{" "}
                <br />
                {exportDefaultSubject}
              </span>
            </div>
          }
          labelCol={{
            span: 24,
          }}
          name="emailSubject"
        >
          <Input maxLength={50} onChange={emailSubjectChanged} />
        </Form.Item>

        <Form.Item
          label={
            <span className="excel-share-modal-grey excel-share-modal-form-label">
              Email Body
            </span>
          }
          name="emailBody"
        >
          <TextArea maxLength={emailBodyMaxLength} onChange={emailBodyChanged}>
            {emailBody}
          </TextArea>
        </Form.Item>
        <span className="excel-share-modal-grey">
          {`${emailBody.replaceAll("\n", "").length}/${emailBodyLimit}`}
        </span>

        <Form.Item name="mailToUser" valuePropName="checked">
          <Checkbox onChange={mailToUserSelected}>
            <span className="excel-share-modal-grey">
              I want to receive a copy of the email
            </span>
          </Checkbox>
        </Form.Item>

        <Form.Item
          wrapperCol={{
            offset: 12,
            span: 12,
          }}
        >
          <Row>
            <Col
              xs={{ span: 11, offset: 1 }}
              sm={{ span: 11, offset: 1 }}
              md={{ span: 11, offset: 1 }}
              lg={{ span: 11, offset: 1 }}
              xl={{ span: 11, offset: 1 }}
              xxl={{ span: 11, offset: 1 }}
            >
              <Button
                onClick={handleClose}
                className="excel-share-cancel-button"
                block
              >
                Cancel
              </Button>
            </Col>
            <Col
              xs={{ span: 11, offset: 1 }}
              sm={{ span: 11, offset: 1 }}
              md={{ span: 11, offset: 1 }}
              lg={{ span: 11, offset: 1 }}
              xl={{ span: 11, offset: 1 }}
              xxl={{ span: 11, offset: 1 }}
            >
              {/* {JSON.stringify(disableSend) + ""} */}
              <Button
                type="primary"
                htmlType="submit"
                block
                disabled={
                  !disableSend.reports ||
                  (!disableSend.recipients && !disableSend.ccUser) ||
                  recipientErrors.length > 0
                }
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                Send
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </>
  );
};

export default ExcelShareForm;
